export default __webpack_public_path__ + "static/preview-e2d665b0204564bd04e23e2afce3482d.png";